class Paging {
    constructor(_pageIndex, _pageSize, _total) {
        this.pageIndex = _pageIndex
        this.pageSize = _pageSize
        this.total = _total
    }
    static default (){
        return new Paging(1, 10,0)
    }
    static get(_pageIndex = 1, _pageSize = 10){
        return new Paging(_pageIndex, _pageSize,0)
    }
    initialIndex (_pageSize = this.pageSize){
        this.pageIndex = 1
        this.pageSize = _pageSize
        return this
    }
    setIndex (_pagingIndex){
        this.pageIndex = _pagingIndex
        return this
    }
    addIndex (){
        this.pageIndex++
        return this
    }
    lessIndex (){
        this.pageIndex--
        return this
    }
    setSize (_pagingSize) {
        this.pageSize = _pagingSize
        return this
    }
    setTotal (_total){
        this.total = _total
        return this
    }
    canPrevious(){
        return this.pageIndex > 1
    }
    canNext(){
        const cacheTotal = this.pageIndex * this.pageSize
        return cacheTotal < this.total
    }
}
export default Paging
